import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

const E911 = ({ e911, opneAddressModal }) => {
  const { number, company, assignedTo, type } = e911;
  return (
    <tr>
      <td>{number || ''}</td>
      <td>{company ?company.name || '' :''}</td>
      <td>{assignedTo ? assignedTo.email : ''}</td>
      <td>{type || ''}</td>
      <td>
        {
          <Button color="primary" onClick={() => opneAddressModal(e911)}>
            Query
          </Button>
        }
      </td>
    </tr>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(E911);
